import { useState } from "react";
import { FormControl, Group } from "@/comn/components";
import { useLogin } from "./useLogin";
import { useTranslation } from "react-i18next";

export const DevAccountButton = (props: any) => {
    const { t } = useTranslation();
    const { DEV_ACCOUNT, type } = props;
    const { loginForm, setLoginForm, devLogin } = useLogin();
    const { lcm } = loginForm;
    const [accounts, setAccounts] = useState<any>({ ESW_TBS: DEV_ACCOUNT["ESW_TBS"] });
    const [account, setAccount] = useState<any>("ESW_TBS");
    let options: any[] = [];
    let account_etc: any = {};

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen((prev) => !prev);
    };

    Object.entries(DEV_ACCOUNT).map(([key, value]: any) => {
        if (String(key).startsWith("ESW_")) {
            options.push({ label: key.substring(4), value: key });
        } else if (key != "CGM_EXT" && key != "CGM_INT") {
            account_etc[key] = value;
        }
    });

    if (
        window.location.hostname === "tanesw.tra.go.tz" ||
        window.location.hostname === "tanoga.tra.go.tz" ||
        window.location.hostname === "ntancis.tra.go.tz"
    )
        return null;

    return (
        <>
            {type === "footer" ? (
                <span onClick={toggle}>&nbsp;© 2025&nbsp;</span>
            ) : (
                <button type="button" className="underline w-fit" onClick={toggle}>
                    Test Account
                </button>
            )}

            {isOpen && (
                <div
                    className="fixed top-[5vh] left-[5vw] bg-white w-[90vw] h-[90vh] rounded shadow"
                    style={{ zIndex: 999999 }}
                >
                    <Group height="100%">
                        <Group.Header>
                            <div className="flex justify-between">
                                <div></div>
                                <button type="button" onClick={toggle}>
                                    {t("B_CLS")}
                                </button>
                            </div>
                        </Group.Header>
                        <Group.Body flex={1}>
                            {DEV_ACCOUNT["ESW_TBS"] && (
                                <div>
                                    <FormControl
                                        type="select"
                                        options={options}
                                        size={6}
                                        selectText="Select an OGA organization"
                                        value={account}
                                        onChange={(value) => {
                                            setAccount(value);
                                            setAccounts({ [value]: DEV_ACCOUNT[value] });
                                        }}
                                    />
                                </div>
                            )}
                            {DEV_ACCOUNT["ESW_TBS"] && account && (
                                <div className="grid grid-cols-1 gap-2 h-full overflow-auto">
                                    {Object.entries(accounts).map(([key, value]: any) => {
                                        return (
                                            <div key={"dev_accounts" + key} className="flex flex-col gap-2">
                                                <div className="font-semibold text-xl">{key}</div>
                                                <ul className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-1">
                                                    {value.map((props: any, index: any) => {
                                                        const { rolenm, tin, cocode, id, pw, type, role, rolenmen } =
                                                            props;
                                                        return (
                                                            <li
                                                                key={(tin || "") + id + index}
                                                                className="group relative p-1 flex flex-col cursor-pointer hover:underline"
                                                                onClick={() => {
                                                                    devLogin({
                                                                        coTpCd: type || "",
                                                                        coCd: cocode || "",
                                                                        coTin: tin || "",
                                                                        id: id || "",
                                                                        pwd: pw || "",
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    <span className="font-semibold">[{rolenmen}]</span>
                                                                    <br />
                                                                    <i className="break-words">
                                                                        {tin && tin}
                                                                        {type && "(" + type + ")"}
                                                                        {cocode && "(" + cocode + ")"}
                                                                    </i>
                                                                    {" / "}
                                                                    <i>{id && id}</i>
                                                                </span>
                                                                {/* <span>{id}</span> */}
                                                                <div className="fixed z-[99999] hidden bottom-[10vh] right-[10vw] bg-white border w-[400px] shadow rounded p-4 gap-8 group-hover:grid grid-cols-2 [&>div]:flex [&>div]:flex-col pointer-events-none">
                                                                    <div>
                                                                        <span className="text-gray text-sm italic">
                                                                            ROLE
                                                                        </span>
                                                                        <span className="font-semibold">
                                                                            {role || "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="text-gray text-sm italic">
                                                                            ROLE NAME
                                                                        </span>
                                                                        <span className="font-semibold">
                                                                            {rolenmen || "-"}
                                                                        </span>
                                                                        <span className="font-semibold">
                                                                            {rolenm || "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="text-gray text-sm italic">
                                                                            TIN
                                                                        </span>
                                                                        <span className="font-semibold">
                                                                            {tin || "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="text-gray text-sm italic">
                                                                            ID
                                                                        </span>
                                                                        <span className="font-semibold">
                                                                            {id || "-"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            <div className="grid grid-cols-1 gap-2 h-full overflow-auto">
                                {/*------------------------------------------------------------*/}
                                {/* CGM External Start */}
                                {/*------------------------------------------------------------*/}
                                {DEV_ACCOUNT["CGM_EXT"] && (
                                    <div key={"dev_accounts_CGM_EXT"} className="flex flex-col gap-2">
                                        <div className="font-semibold text-2xl">CGM</div>
                                        <ul className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-1">
                                            {Object.entries(DEV_ACCOUNT["CGM_EXT"]).map(
                                                ([title, userArr]: any, idx) => {
                                                    return (
                                                        <li key={title} className="relative p-1 flex flex-col">
                                                            <span>
                                                                <span className="font-semibold text-xl">[{title}]</span>
                                                                <br />

                                                                {userArr.map((obj: any, idx: number) => {
                                                                    let is_cgm0189_warehouse =
                                                                        obj.cocode == "WTTZDL001" ||
                                                                        obj.cocode == "WTTZDL002" ||
                                                                        obj.cocode == "WITZDL008";

                                                                    return (
                                                                        <div key={title + "_" + idx} className="group">
                                                                            <i
                                                                                className={
                                                                                    "text-lg break-words cursor-pointer hover:underline" +
                                                                                    (is_cgm0189_warehouse
                                                                                        ? "text-decoration: line-through"
                                                                                        : "")
                                                                                }
                                                                                onClick={() => {
                                                                                    devLogin({
                                                                                        coTpCd: obj.type || "",
                                                                                        coCd: obj.cocode || "",
                                                                                        coTin: obj.tin || "",
                                                                                        id: obj.id,
                                                                                        pwd: obj.pw,
                                                                                    });
                                                                                }}
                                                                            >
                                                                                {obj.type ? "(" + obj.type + ")" : ""}{" "}
                                                                                {obj.rolenmen} ({obj.tin})
                                                                            </i>
                                                                            <div className="fixed z-[99999] hidden bottom-[10vh] right-[10vw] bg-white border w-[400px] shadow rounded p-4 gap-8 group-hover:grid grid-cols-2 [&>div]:flex [&>div]:flex-col pointer-events-none">
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ROLE
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.role || "-"}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ROLE NAME
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.rolenmen || "-"}
                                                                                    </span>
                                                                                    {/* 
                                                                        <span className="font-semibold">
                                                                            {obj.rolenm || "-"}
                                                                        </span>
                                                                         */}
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        Name
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.name || "-"}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ID
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.id || "-"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <br />
                                                                        </div>
                                                                    );
                                                                })}
                                                            </span>
                                                        </li>
                                                    );
                                                },
                                            )}
                                            {/* End Object.entries(DEV_ACCOUNT["CGM_INT"]) */}
                                        </ul>
                                        <br />
                                        <br />
                                    </div>
                                )}
                                {/*------------------------------------------------------------*/}
                                {/* CGM External End */}
                                {/*------------------------------------------------------------*/}

                                {/*------------------------------------------------------------*/}
                                {/* CGM Internal Start */}
                                {/*------------------------------------------------------------*/}
                                {DEV_ACCOUNT["CGM_INT"] && (
                                    <div key={"dev_accounts_CGM_INT"} className="flex flex-col gap-2">
                                        <div className="font-semibold text-2xl">CGM</div>
                                        <ul className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-1">
                                            {Object.entries(DEV_ACCOUNT["CGM_INT"]).map(
                                                ([title, userArr]: any, idx) => {
                                                    return (
                                                        <li key={title} className="relative p-1 flex flex-col">
                                                            <span>
                                                                <span className="font-semibold text-xl">[{title}]</span>
                                                                <br />

                                                                {userArr.map((obj: any, idx: number) => {
                                                                    let shortPrint = obj.shortPrintYn === "Y";

                                                                    return shortPrint ? (
                                                                        obj.type === "" ? (
                                                                            <br />
                                                                        ) : (
                                                                            <>
                                                                                <span
                                                                                    className="text-lg break-words cursor-pointer hover:underline"
                                                                                    style={{
                                                                                        fontSize: "14px",
                                                                                        fontFamily: "Consolas",
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        devLogin({
                                                                                            coTpCd: obj.type,
                                                                                            coCd: "",
                                                                                            coTin: "",
                                                                                            id: obj.id,
                                                                                            pwd: obj.pw,
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    ({obj.type})
                                                                                </span>
                                                                                &nbsp;&nbsp;
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        <div key={title + "_" + idx} className="group">
                                                                            <i
                                                                                className="text-lg break-words cursor-pointer hover:underline"
                                                                                onClick={() => {
                                                                                    devLogin({
                                                                                        coTpCd: obj.type,
                                                                                        coCd: "",
                                                                                        coTin: "",
                                                                                        id: obj.id,
                                                                                        pwd: obj.pw,
                                                                                    });
                                                                                }}
                                                                            >
                                                                                ({obj.type}) {obj.rolenmen}
                                                                            </i>
                                                                            <div className="fixed z-[99999] hidden bottom-[10vh] right-[10vw] bg-white border w-[400px] shadow rounded p-4 gap-8 group-hover:grid grid-cols-2 [&>div]:flex [&>div]:flex-col pointer-events-none">
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ROLE
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.role || "-"}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ROLE NAME
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.rolenmen || "-"}
                                                                                    </span>
                                                                                    {/* 
                                                                        <span className="font-semibold">
                                                                            {obj.rolenm || "-"}
                                                                        </span>
                                                                         */}
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        Name
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.name || "-"}
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="text-gray text-sm italic">
                                                                                        ID
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {obj.id || "-"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <br />
                                                                        </div>
                                                                    );
                                                                })}
                                                            </span>
                                                        </li>
                                                    );
                                                },
                                            )}
                                            {/* End Object.entries(DEV_ACCOUNT["CGM_INT"]) */}
                                        </ul>
                                        <br />
                                        <br />
                                    </div>
                                )}
                                {/*------------------------------------------------------------*/}
                                {/* CGM Internal End */}
                                {/*------------------------------------------------------------*/}

                                {Object.entries(account_etc).map(([key, value]: any) => {
                                    return (
                                        <div key={"dev_accounts" + key} className="flex flex-col gap-2">
                                            <div className="font-semibold text-xl">{key}</div>
                                            <ul className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-2 gap-1">
                                                {value.map((props: any, index: any) => {
                                                    const { rolenm, tin, cocode, id, pw, type, role, rolenmen } = props;
                                                    return (
                                                        <li
                                                            key={(tin || "") + id + index}
                                                            className="group relative p-1 flex flex-col cursor-pointer hover:underline"
                                                            onClick={() => {
                                                                devLogin({
                                                                    coTpCd: type || "",
                                                                    coCd: cocode || "",
                                                                    coTin: tin || "",
                                                                    id: id || "",
                                                                    pwd: pw || "",
                                                                });
                                                            }}
                                                        >
                                                            <span>
                                                                <span className="font-semibold">[{rolenmen}]</span>
                                                                <br />
                                                                <i className="break-words">
                                                                    {tin && "(" + tin + ")"}
                                                                    {type && "(" + type + ")"}
                                                                    {cocode && "(" + cocode + ")"}
                                                                </i>
                                                            </span>
                                                            {/* <span>{id}</span> */}
                                                            <div className="fixed z-[99999] hidden bottom-[10vh] right-[10vw] bg-white border w-[400px] shadow rounded p-4 gap-8 group-hover:grid grid-cols-2 [&>div]:flex [&>div]:flex-col pointer-events-none">
                                                                <div>
                                                                    <span className="text-gray text-sm italic">
                                                                        ROLE
                                                                    </span>
                                                                    <span className="font-semibold">{role || "-"}</span>
                                                                </div>
                                                                <div>
                                                                    <span className="text-gray text-sm italic">
                                                                        ROLE NAME
                                                                    </span>
                                                                    <span className="font-semibold">
                                                                        {rolenmen || "-"}
                                                                    </span>
                                                                    <span className="font-semibold">
                                                                        {rolenm || "-"}
                                                                    </span>
                                                                </div>
                                                                <div>
                                                                    <span className="text-gray text-sm italic">
                                                                        TIN
                                                                    </span>
                                                                    <span className="font-semibold">{tin || "-"}</span>
                                                                </div>
                                                                <div>
                                                                    <span className="text-gray text-sm italic">ID</span>
                                                                    <span className="font-semibold">{id || "-"}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    );
                                })}
                            </div>
                        </Group.Body>
                        <Group.Footer>
                            <label className="flex items-center gap-1">
                                license
                                <input
                                    type="checkbox"
                                    checked={lcm}
                                    onChange={(event) => {
                                        setLoginForm((prev) => ({ ...prev, lcm: event.target.checked }));
                                    }}
                                />
                            </label>
                        </Group.Footer>
                    </Group>
                </div>
            )}
        </>
    );
};
